import React from 'react';
import useHints from './useHints';
import './Hint.css';

/* A "how to" hint: a small callout pointing at whatever it wraps, shown to
 * every user until they press "Got it" — then never again for them.
 *
 *   <Hint id="results-map" title="See these on a map"
 *         text="Switch to Map to…" placement="bottom-end" show={hasResults}>
 *       <button>Map</button>
 *   </Hint>
 *
 * id:        unique slug; a new id is a new hint (no migration needed).
 * show:      extra condition, e.g. only when there's something to point at.
 * placement: 'bottom-start' | 'bottom-end' — which edge the bubble lines up
 *            with under the wrapped element.
 * To dismiss when the user does the thing the hint is about, call
 * useHints().dismiss(id) from that handler. */
const Hint = ({ id, title, text, placement = 'bottom-start', show = true, children }) => {
    const { isOpen, dismiss } = useHints();
    const open = show && isOpen(id);

    return (
        <span className="hint-anchor">
            {children}
            {open && (
                <span className={`hint-bubble hint-${placement}`} role="note">
                    <span className="hint-arrow" aria-hidden="true" />
                    {title && <strong className="hint-title">{title}</strong>}
                    <span className="hint-text">{text}</span>
                    <button type="button" className="hint-dismiss" onClick={() => dismiss(id)}>
                        Got it
                    </button>
                </span>
            )}
        </span>
    );
};

export default Hint;
